// context/DateRangeContext.tsx
import React, { createContext, useContext, useState } from "react";
import dayjs, { Dayjs } from "dayjs";

interface DateRange {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

interface DateRangeContextType {
  dateRange: DateRange;
  setDateRange: React.Dispatch<React.SetStateAction<DateRange>>;
}

const defaultRange: DateRange = {
  startDate: dayjs().startOf("week"),
  endDate: dayjs().endOf("week"),
};

const DateRangeContext = createContext<DateRangeContextType | undefined>(undefined);

export const DateRangeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dateRange, setDateRange] = useState<DateRange>(defaultRange);

  return (
    <DateRangeContext.Provider value={{ dateRange, setDateRange }}>
      {children}
    </DateRangeContext.Provider>
  );
};

export const useDateRange = (): DateRangeContextType => {
  const context = useContext(DateRangeContext);
  if (!context) throw new Error("useDateRange must be used within a DateRangeProvider");
  return context;
};
